/** Формат отображения и ввода телефона: +7 XXX XXX XXXX (3 + 3 + 4) */

export function digitsOnly(s: string): string {
  return s.replace(/\D/g, '')
}

/** Отображение: всегда +7 и группы по маске */
export function formatPhoneDisplay(raw: string | null | undefined): string {
  if (raw == null || raw === '') return '—'
  let d = digitsOnly(raw)
  if (d.startsWith('8')) d = '7' + d.slice(1)
  if (!d.startsWith('7')) d = '7' + d
  d = d.slice(0, 11)
  const rest = d.slice(1)
  const a = rest.slice(0, 3)
  const b = rest.slice(3, 6)
  const c = rest.slice(6, 10)
  let out = '+7'
  if (a) out += ` ${a}`
  if (b) out += ` ${b}`
  if (c) out += ` ${c}`
  return out.trimEnd()
}

/** При вводе: держим +7 и ограничиваем 11 цифрами */
export function formatPhoneInput(_prev: string, next: string): string {
  let d = digitsOnly(next)
  // В поле уже стоит «+7», а вставили номер с кодом страны («+7 926…»,
  // «8 926…», «7926…»): получается 12 цифр с лишним кодом впереди. Российских
  // номеров, начинающихся на 7 или 8 после кода, нет, так что первую цифру
  // отбрасываем, иначе обрезалась бы последняя цифра номера.
  if (d.length > 11 && d.startsWith('7') && (d[1] === '7' || d[1] === '8')) d = d.slice(1)
  if (d.startsWith('8')) d = '7' + d.slice(1)
  if (!d.startsWith('7') && d.length > 0) d = '7' + d.replace(/^7+/, '')
  d = d.slice(0, 11)
  const rest = d.slice(1)
  const a = rest.slice(0, 3)
  const b = rest.slice(3, 6)
  const c = rest.slice(6, 10)
  let out = '+7'
  if (a) out += ` ${a}`
  if (b) out += ` ${b}`
  if (c) out += ` ${c}`
  return out.trimEnd()
}
